export function compareWithKeys(objectA: any, objectB: any, keys: string[]): boolean {
  let isChange = false;
  keys.every(key => {
    if (objectA[key] === objectB[key]) {
      return true;
    }
    isChange = true;
    return false;
  })

  return isChange;
}

export function formatPostalCode(postalCode: string): string {
  return postalCode.includes('-') ? postalCode : postalCode.replace(/(\d{3})(\d{4})/g, '$1-$2');
}



// copy input type from core system
export const InputTypes = {
  "Text": "",
  "Day": "",
  "TELFAX": "",
  "NumCode": "", // 郵便番号
  "Number": ""
} as const;
export type InputType = keyof typeof InputTypes;

export class InputPolicy {
  static check(input: string, type: InputType): string {
    if (input) {
      switch (type) {
        case "Text": return this.forText(input);
        case "TELFAX": return this.forTelFax(input);
        case "Day": return this.forDay(input);
        case "NumCode": return this.forNumCode(input);
        case "Number": return this.forNumCode(input);
      }
    }
    return input;
  }

  static forText(input: string): string {
    return input.replace(/[\']/g, '');
  }

  static forTelFax(input: string): string {
    return input.replace(/[^0-9\-\+\(\)]/g, '');
  }

  static forDay(input: string): string {
    return input.replace(/[^0-9\-]/g, '');
  }

  static forNumCode(input: string): string {
    return input.replace(/[^0-9\-]/g, '');
  }
  static forNumber(input: string): string {
    return input.replace(/[^0-9]/g, '');
  }
}


export const CountLengthAsSjis = (str: string): number => {
  var r = 0;
  for (var i = 0; i < str.length; i++) {
    var c = str.charCodeAt(i);
    // Shift_JIS: 0x0 ～ 0x80, 0xa0 , 0xa1 ～ 0xdf , 0xfd ～ 0xff
    // Unicode : 0x0 ～ 0x80, 0xf8f0, 0xff61 ～ 0xff9f, 0xf8f1 ～ 0xf8f3
    if ((c >= 0x0 && c < 0x81) || (c == 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
      r += 1;
    } else {
      r += 2;
    }
  }
  return r;
}

export const MaxBiteFilter = (str: string, maxBite: number): string => {
  var r = 0;
  var result = "";
  var current = 0;
  if (!str) {
    return result;
  }
  for (var i = 0; i < str.length; i++) {
    var c = str.charCodeAt(i);
    // Shift_JIS: 0x0 ～ 0x80, 0xa0 , 0xa1 ～ 0xdf , 0xfd ～ 0xff
    // Unicode : 0x0 ～ 0x80, 0xf8f0, 0xff61 ～ 0xff9f, 0xf8f1 ～ 0xf8f3
    if ((c >= 0x0 && c < 0x81) || (c == 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
      current = 1;
    } else {
      current = 2;
    }

    if (maxBite < r + current) {
      return result;
    } else {
      result += str[i];
      r += current;
    }
  }

  return result;
};


export function makeid(length = 30) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() *
      charactersLength));
  }
  return result;
}
